import * as api from 'config/api';
// import useSWR from 'swr';
import { useQuery } from 'react-query';
import { convertFromString } from 'utils/date';
import { formatDate } from 'utils/formatter';

const toDateNumber = (date: Date) =>
  date.getFullYear() * 10000 + date.getMonth() * 100 + date.getDate();
const targetYearAge = (targetDate: Date, birthday: Date) =>
  Math.floor((toDateNumber(targetDate) - toDateNumber(birthday)) / 10000);

export const calculateRemainTargetDate = ({
  birthday,
  targetDate,
}: {
  birthday: Date;
  targetDate: Date;
}): {
  year: number;
  month: number;
  age: number;
} => {
  const toMonthNumber = (date: Date) =>
    date.getFullYear() * 12 + date.getMonth();
  const remainMonths = toMonthNumber(targetDate) - toMonthNumber(new Date());
  return {
    age: targetYearAge(targetDate, birthday),
    month: remainMonths % 12,
    year: Math.floor(remainMonths / 12),
  };
};

export const calculateTargetDate = ({
  birthday,
  targetDate,
}: {
  birthday: Date;
  targetDate: Date;
}): { year: number; month: number; age: number } => {
  return {
    age: targetYearAge(targetDate, birthday),
    month: targetDate.getMonth(),
    year: targetDate.getFullYear(),
  };
};

export type StatusProps = 'Success' | 'Error';

export const useBirthday = (): {
  birthday: Date | null | undefined;
  isFetched: boolean;
  refetchBirthday: () => Promise<void>;
  setBirthday: (birthday: Date) => Promise<{ status: StatusProps }>;
} => {
  const { data, isFetched, refetch } = useQuery(
    'useBirthday',
    () => birthdayAPI(),
    {
      refetchOnWindowFocus: false,
    }
  );
  const birthday = data;

  const refetchBirthday = async () => {
    await refetch();
  };

  const setBirthday = async (birthday: Date) => {
    const ret = await api.updateUser({
      Birthday: formatDate(birthday, 'yyyy-MM-dd'),
    });
    if (ret.Success) return { status: 'Success' as StatusProps };
    return { status: 'Error' as StatusProps };
  };

  return {
    birthday,
    isFetched,
    refetchBirthday,
    setBirthday,
  };
};

const birthdayAPI = async () => {
  const ret = await api.getUser();
  return ret.Birthday ? convertFromString(ret.Birthday, true) : null;
};
